import { calculateExpirationDate } from './calculateExpirationDate.utils'
import { calculateFPLPercentage } from '@app-store'

export const toLookupRef = (id: unknown): { id: number } | null => {
  if (id == null || id === '') return null
  const numericId = Number(id)
  return Number.isNaN(numericId) ? null : { id: numericId }
}

export const getValue = (value: string) => {
  if (value == null || value === '') return null
  return value
}

export const getCurrentDateTime = (): string => new Date().toISOString()

export const PARAMLESS_FORM_RULE_FUNCTIONS = new Set<string>([
  'getCurrentDateTime',
])

export const isParamlessFormRuleFunction = (name: string): boolean =>
  PARAMLESS_FORM_RULE_FUNCTIONS.has(name)

export const FORM_RULE_FUNCTIONS = {
  calculateExpirationDate,
  calculateFPLPercentage,
  toLookupRef,
  getValue,
  getCurrentDateTime,
} as const

export type FormRuleFunctionName = keyof typeof FORM_RULE_FUNCTIONS

export const isFormRuleFunctionName = (
  name: string
): name is FormRuleFunctionName =>
  Object.prototype.hasOwnProperty.call(FORM_RULE_FUNCTIONS, name)
